(ns frontend.ui.component.checkbox.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]))

(defn- regular-label
  [{:keys [disabled?]}]
  (merge
   {:display        "flex"
    :flex-direction "row"
    :user-select    "none"
    :color          (theme/color [:checkbox :custom-label :enabled :fg])}
   (when disabled?
     {:color (theme/color [:checkbox :regular-label :disabled])})))

(defn- custom-label
  [{:keys [checked? disabled? fg-color bg-color]}]
  (merge
   {:display        "flex"
    :flex-direction (if checked? "row-reverse" "row")
    :border-radius  "1rem"
    :padding        "4px"
    :user-select    "none"}
   (if disabled?
     {:background-color (theme/color [:checkbox :custom-label :disabled :bg])
      :color (or fg-color
                 (theme/color [:checkbox :custom-label :disabled :fg]))}
     {:background-color (if checked?
                          (theme/color [:checkbox :custom-label :enabled :bg :checked])
                          (theme/color [:checkbox :custom-label :enabled :bg :unchecked]))
      :color  (theme/color [:checkbox :custom-label :enabled :fg])
      :cursor "pointer"})))

(defn label
  [{:keys [custom?] :as props}]
  (if custom?
        (custom-label props)
        (regular-label props)))

(defn custom-handle
  []
  {:background-color (theme/color [:checkbox :custom-handle :bg])
   :height        "20px"
   :width         "20px"
   :border-radius "100%"})

(defn input
  []
  ;; Hide the HTML checkbox
  {:position "absolute"
   :opacity  0
   :cursor   "pointer"
   :height   0
   :width    0})

(defn regular-icon
  [{:keys [checked? disabled?]}]
  {:color         (cond
                    disabled? (theme/color [:checkbox :regular-icon :disabled :fg])
                    checked? (theme/color [:checkbox :regular-icon :checked :fg])
                    :else (theme/color [:checkbox :regular-icon :fg]))
   :font-size     "20px"
   :cursor        "pointer"
   :padding-right "10px"})

(defn text
  [{:keys [custom?]}]
  (if custom?
    {:display     "block"
     :line-height "1.5"
     :font-size   "12px"
     :padding     "0 4px"
     :color       (theme/color [:checkbox :text :custom :fg])
     :min-width   "24px"}
    {:margin-left "12px"}))
